const BASE_NAME = 'referral_module';

const SET_STREAK_REFERRAL_MODAL = `${BASE_NAME
}/SET_STREAK_REFERRAL_MODAL_STATE`;
const SET_POST_SHARE_LINKEDIN = `${BASE_NAME
}/SET_POST_SHARE_LINKEDIN`;
const SET_REFERRAL_INFO_MODAL = `${BASE_NAME
}/SET_REFERRAL_INFO_MODAL`;
const SET_END_STATE_MODAL = `${BASE_NAME
}/SET_END_STATE_MODAL`;

const initialState = {
  modalState: true,
  linkedinFormState: true,
  referralInfoModalState: false,
  endStateModalState: false,
};

export function setStreakReferralModal(modalState) {
  return {
    type: SET_STREAK_REFERRAL_MODAL,
    payload: modalState,
  };
}

export function setPostShareLinkedin(formState) {
  return {
    type: SET_POST_SHARE_LINKEDIN,
    payload: formState,
  };
}

export function setReferralInfoModalState(formState) {
  return {
    type: SET_REFERRAL_INFO_MODAL,
    payload: formState,
  };
}

export function setEndStateModalState(formState) {
  return {
    type: SET_END_STATE_MODAL,
    payload: formState,
  };
}

export default function streakReferralModalReducer(
  state = initialState,
  action,
) {
  switch (action.type) {
    case SET_STREAK_REFERRAL_MODAL: {
      return {
        ...state,
        modalState: action.payload,
      };
    }
    case SET_POST_SHARE_LINKEDIN: {
      return {
        ...state,
        linkedinFormState: action.payload,
      };
    }
    case SET_REFERRAL_INFO_MODAL: {
      return {
        ...state,
        referralInfoModalState: action.payload,
      };
    }
    case SET_END_STATE_MODAL: {
      return {
        ...state,
        endStateModalState: action.payload,
      };
    }
    default:
      return state;
  }
}
